import React , { useState } from 'react';
import HeaderSideBar from './HeaderSideBar'; 
import { Link } from 'react-router-dom';
import { cookieStorageUtility, localStorageUtility } from '../../utils/utilityFunctions';
import Loader from '../Common/Loader';
import constants from '../../constants';
import { checkRole } from '../Common/CheckRole';

const { SSO_AUTH_URL, REDIRECT_URL, APP_KEY, ENCRYPTOR_KEY } = constants;
const identity = localStorageUtility.fetch('identity');
const HeaderView = () => {
  let [showUILoader, setShowUILoader] = useState(true);
  let [showSidebar, setShowSidebar] = useState(false);

 
  const toggleSideBar = () => {
    setShowSidebar(prev => !prev); // toggle value
  };

  const logout = () => {
    localStorageUtility.delete('identity');
    localStorageUtility.delete('isLoggedIn');
    cookieStorageUtility.delete('hotelId');
    cookieStorageUtility.delete('auth_user_id');
    cookieStorageUtility.delete('encrypted_' + ENCRYPTOR_KEY + '_token');
    cookieStorageUtility.delete('lastLogedInActivityAt');
    // window.open(REDIRECT_URL, '_self'); // uncomment for login screen
    window.open(SSO_AUTH_URL + 'sign_out?redirect_url=' + REDIRECT_URL + '&app_key=' + APP_KEY, '_self'); // comment to de-activate sso login
  };
  
  return (
    <header>
      {/* {showUILoader && <Loader />} */}
      {showSidebar && <HeaderSideBar toggleSideBar={toggleSideBar} />}
      {/* <HeaderSideBar/> */}
      <div className="container_fluid pad_left15">
        <div className="cover">
          <div className="row no-gutters">
            <div className="col-xs-12 col-md-9">
              <div className="cover">
                <div className="row no-gutters">
                  <div className="col-xs-12 col-sm-auto">
                    <div className="d-full-height justify-content-center">
                      <div className="redCMlogo">
                        {/* Logo should navigate to home */}
                        <img src="/images/logo.png" alt="Reddoorz.com" />
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm">
                    <div className="menu text-start">
                      <ul>
                        <li><Link to="/">Bookings</Link></li>
                        <li><Link to="/rate-inventory"> Rate & Inventory </Link></li>
                        <li>
                          <a href="#">Setup <i className="fa fa-caret-down"></i></a>
                          <div className="menuabso shwd1">
                            <ul>
                              <li><Link to="/roomcategory"> Room Category </Link></li>
                              <li><Link to="/rateplan"> Rate Plans </Link></li>
                               {checkRole('edit_property') ? <li><Link to={`/property/setup/${identity.hotel_id}`}> Setting  </Link></li> : ''}
                             
                            </ul>
                          </div>
                        </li>
                        <li>
                          <a href="#">Channel Manager <i className="fa fa-caret-down"></i></a>
                          <div className="menuabso shwd1">
                            <ul>
                              <li><Link to="/channelmanager/mychannel">My Channels</Link></li>
                              <li><Link to="/channelmanager/allchannel">All Channels</Link></li>
                               {checkRole('upload_mapping_markup')
                                  ?<li><Link to="/channelmanager/uploadmapping">Upload New Mapping/Markup</Link></li>
                                : ''}
                              
                              {checkRole('download_mapping')
                                  ?<li><Link to="/channelmanager/mapping/download">Download Mapping</Link></li>
                              : ''}
                              {checkRole('upload_markup')
                                  ?<li><Link to="/channelmanager/markup">Upload Markup</Link></li>
                              : ''}
                              {/* <li><Link to="/channelmanager/decreaseinventory">Upload New Decrease Inventory</Link></li> */}
                              <li><Link to="/channelmanager/markup_daywise">Markup List</Link></li>
                              {/* <li><Link to="#">Redpartner Requests</Link></li> */}
                              <li> <Link to="/channelmanager/negative_derivative">Negative Derivative</Link></li>
                            </ul>
                          </div>
                        </li>
                        <li>
                          <Link to="#">Logs <i className="fa fa-caret-down"></i></Link>
                          <div className="menuabso shwd1">
                            <ul>
                              <li><Link to="/log/channellog">Channel Log</Link></li>
                              <li><Link to="/log/pushdatalog">Push Data Log</Link></li>
                              <li><Link to="/log/pmslog">PMS Log</Link></li>
                              <li><Link to="/log/activitylog">Activity Log</Link></li>
                            </ul>
                          </div>
                        </li>
                        {(checkRole('create_role') || checkRole('assign_role'))
                          ?
                          <li>
                            <a href="#">Admin <i className="fa fa-caret-down"></i></a>
                            <div className="menuabso shwd1">
                              <ul>
                                <li><Link to="/users">Users</Link></li>
                                <li><Link to="/roles">Roles</Link></li>
                                {(checkRole('vcc_charge_log'))
                                  ? <li><Link to="/payment/dashboard">Payment Dashboard</Link></li>
                                  : ''}
                                <li><Link to="/payment/bulk_charge">Bulk Charge</Link></li>
                                <li><Link to="channelmanager/sync">Channel Sync</Link></li>
                              </ul>
                            </div>
                          </li>
                        : ''}
                         <li>
                            <a href="#">Onboarding Dashboard <i className="fa fa-caret-down"></i></a>
                            <div className="menuabso shwd1">
                              <ul>
                                <li><Link to="/airbnb">Airbnb</Link></li>
                              </ul>
                              </div>
                          </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-md-3">
              <div className="cover">
                <div className="row no-gutters justify-content-end text-start">
                  <div onClick={() => toggleSideBar(true)} className="col-xs" id="displayHotelName">
                    <div className="d-full-height justify-content-center pad_right25 header_sidebar_open">
                      <div className="ovr border_all_1 border_color_1 pad10">
                        <div className="table_col table_fixed">
                          <div className="tabcel align_middle">
                            <div className="ovr cursor_p fnt15 bld" title="Hotel Name">{identity.hotel_name}</div>

                          </div>
                          <div className="tabcel align_middle wdhpx30 tr fnt16"><i className="fa fa-arrow-circle-right"></i></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-auto">
                    <div className="usname">
                      <div className="usericon bg3">
                        <i className="fa fa-user color1 bgcolr2 full-round tc"></i>
                      </div>
                      <div className="userabso shwd1 text-start">
                        <ul>
                          <li>
                            {/* Logout is an action, so use button */}
                            <button type="button" title="Logout" className="link-button" onClick={() => logout()}><i className="fa fa-chevron-right"></i> Logout</button>
                          </li>
                          <li>
                            <p> Logged in as {identity.name}</p>
                          </li>
                          <li>
                            <p>Last login : {identity.last_logged_in}</p>
                          </li>
                          <li>
                            <p>Timezone : {identity.time_zone}</p>
                          </li>
                          <li>
                            <p className="bld">Hotel : {identity.hotel_name}</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderView;
